export const manageHover = (id: string) => {
    const img = document.getElementById(id);
    if (img) {
        // @ts-ignore
        const assetSource = img.src;
        // @ts-ignore
        img.src = ''
        // @ts-ignore
        img.src = assetSource
    }
}